import { UserForAuth, RolesWithPermissions } from '../types';

import { Permissions } from '../permissions';

import { ABAC } from '../abac';

// only function you'll ever need to use for setting up guards on resources
// checks if the given user has permission to perform the given action on the given resource
// if `data` is provided, it checks permission for that specific resource instance
// otherwise it checks whether permission is granted for any resource instance of that type

export function hasPermission<Resource extends keyof Permissions>(
  user: UserForAuth,
  resource: Resource,
  action: Permissions[Resource]['action'],
  data?: Permissions[Resource]['dataType'],
) {
  return user.roles.some((role) => {
    if (role === 'admin') return true;

    const permission = (ABAC as RolesWithPermissions)[role][resource]?.[action];
    if (permission == null) return false;

    if (typeof permission === 'boolean') return permission;
    return data != null && permission(user, data);
  });
}
